module.exports = __webpack_public_path__ + "img/filterArrowClose-white.55f872db.png";